import { normalizePathname } from '@zapier/url-utils';
export const isLinkSelected = (linkHref, currentPageHref) => {
    let parsedCurrentPageHref;
    let parsedLinkHref;
    try {
        parsedCurrentPageHref = new URL(currentPageHref);
        parsedLinkHref = new URL(linkHref);
    }
    catch (_a) {
    }
    if (!parsedLinkHref) {
        return normalizePathname((parsedCurrentPageHref === null || parsedCurrentPageHref === void 0 ? void 0 : parsedCurrentPageHref.pathname) || currentPageHref).startsWith(normalizePathname(linkHref));
    }
    return normalizePathname(currentPageHref).startsWith(normalizePathname(linkHref));
};
//# sourceMappingURL=utils.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
